import React from 'react';
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '../../../components/ui/select';
import { cn } from '../../../lib/utils';

/**
 * Dropdown built on the app's global Select (Radix) so it looks and behaves
 * like every other dropdown in the product.
 *
 * options: [{ value, label }]  - value may be a string or number; onChange
 * receives the original option value.
 */
export const OTRSelect = ({
  value,
  onChange,
  options = [],
  placeholder = 'Select...',
  disabled = false,
  hasError = false,
  compact = false,
  className,
}) => {
  const current =
    value === null || value === undefined || value === '' ? undefined : String(value);

  return (
    <Select
      value={current}
      disabled={disabled}
      onValueChange={(next) => {
        const match = options.find((o) => String(o.value) === next);
        onChange?.(match ? match.value : next);
      }}
    >
      <SelectTrigger
        className={cn(
          'w-full rounded-xl border bg-white text-sm focus:ring-[var(--color-accent)]',
          compact ? 'h-9 px-2 text-[12px] font-bold rounded-lg' : 'h-11 px-3',
          hasError ? 'border-[var(--color-error)]' : 'border-[var(--color-text-border)]',
          className
        )}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-h-60 overflow-y-auto">
        {options.map((option) => (
          <SelectItem key={String(option.value)} value={String(option.value)}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
